import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Form, Formik } from "formik";
import * as yup from "yup";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  blackColor,
  DatePickerField,
  CheckboxField,
  DRxTextareaStyle,
  DRxSelectStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import DRxInput from "../../../uikit/DRxInput";
import DRxTextarea from "../../../uikit/DRxTextarea";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import {
  InitializeAllergyForEdit,
  UpdateAllergy,
} from "../../../Apis/AuthApiServices";
import { useDispatch, useSelector } from "react-redux";
import { loadingDrugSearchAjax } from "../../../Redux/Slice/DrugSearchAjaxSlice";
import { YSSelectSearch } from "../../../uikit/YSSelectSearch";
import { useEffect, useState } from "react";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { loadingPatientDetails } from "../../../Redux/Slice/PatientDetailsSlice";

const initialEditValues = {
  editDrugName: "",
  editDrugId: "",
  otherRecations: "",
  onSetDate: "",
  note: "",
  AllergiesList: [],
};
export default function EditAllergies(props: any) {
  const { rowData } = props;
  const [data, setData] = useState<any>(initialEditValues);
  const [loading, setLoading] = useState(true);
  const [AddorEditState, setAddorEditState] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const patientId: any = sessionStorage.getItem("patientId");
  const Params = {
    patientId: patientId,
    drugId: rowData?.drugId,
    drugName: rowData?.drugName,
  };
  const getInitialEditData = async () => {
    try {
      const params = new URLSearchParams(Params);
      const result = await InitializeAllergyForEdit(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        let array: any = [];
        result?.data?.response[0]?.allergiesList?.map(
          (item: any) => item?.allergyFlag && array.push(item?.allergyId)
        );
        setData({ ...result?.data?.response[0], AllergiesList: [...array] });

        let drugName = {
          drugName: result?.data?.response[0]?.editDrugName,
        };
        dispatch(loadingDrugSearchAjax(drugName));
      } else {
        setData({});
      }
      setLoading(false);
    } catch (error) {}
  };
  useEffect(() => {
    getInitialEditData();
  }, []);

  const EditAllergy = async (values: any) => {
    const doctorId = localStorage.getItem("doctorId");
    try {
      const Postdata = {
        drugName: values.editDrugName ?? "",
        drugId: values.editDrugId ?? "",
        otherRecation: values.otherRecations ?? "",
        note: values.note ?? "",
        onSetDate: values.onSetDate ?? "",
        patientId: values.patientId ?? "",
        doctorId: doctorId,
        selectedAllergies: values.AllergiesList ?? [],
      };
      const result = await UpdateAllergy(Postdata);

      if (result?.data?.digitalRxStatusCode === 200) {
        setAddorEditState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHidePopupClick();
          props.getAllergiesData(0);
          dispatch(loadingPatientDetails());
        }, 2000);
      } else {
        setAddorEditState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setAddorEditState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const dispatch = useDispatch();
  const DrugSearchAjaxState = useSelector((state: any) => {
    return { ...state.DrugSearchAjaxSlice };
  }); //redux data

  return (
    <>
      {loading ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"30vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <Formik
          initialValues={data}
          enableReinitialize={true}
          validationSchema={yup.object().shape({
            editDrugName: yup
              .string()
              .required("Drug name is required.")
              .max(32)
              .min(4)
              .typeError("First four letters of Drug name are required."),

            otherRecations: yup.string().when("AllergiesList", {
              is: (AllergiesList: any) =>
                !AllergiesList || AllergiesList.length === 0,
              then: yup
                .string()
                .required(
                  "Please enter your reaction or select from above reactions"
                )
                .nullable(),
              otherwise: yup.string().notRequired().nullable(),
            }),
          })}
          onSubmit={(values) => {
            EditAllergy(values);
          }}
        >
          {(registerProps) => (
            <Form onSubmit={registerProps.handleSubmit}>
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="flex-start"
              >
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={blackColor}
                      fontWeight={"400"}
                      htmlFor="searchby"
                      marginBottom={3}
                    >
                      Drug Name
                      <Typography
                        component="span"
                        color="error"
                        variant="body2"
                      >
                        *
                      </Typography>
                    </Typography>
                    <DRxSelectStyle>
                      {" "}
                      <YSSelectSearch
                        id="searchby"
                        options={
                          DrugSearchAjaxState?.Items?.map(
                            (item: any, index: any) => ({
                              id: item.drugId,
                              label: item.drugName,
                            })
                          ) ?? [{ id: "", label: "" }]
                        }
                        isOptionEqualToValue={(option: any, value: any) =>
                          option.label === value
                        }
                        name="editDrugName"
                        value={registerProps.values.editDrugName}
                        onInputChange={(event: any, value: any) => {
                          registerProps.setFieldValue("editDrugName", value);

                          let drugName = {
                            drugName: value,
                          };
                          if (value.length >= 4) {
                            dispatch(loadingDrugSearchAjax(drugName));
                          }
                        }}
                        onChange={(event: any, value: any) => {
                          registerProps.setFieldValue("editDrugId", value.id);
                        }}
                        error={
                          registerProps.touched.editDrugName &&
                          Boolean(registerProps.errors.editDrugName)
                        }
                      />
                    </DRxSelectStyle>
                  </InputSMBoxStyle>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Typography
                    component="label"
                    color={blackColor}
                    variant="body2"
                  >
                    My Reactions to this drug are:{" "}
                    <Typography component="span" color="error" variant="body2">
                      *
                    </Typography>
                    <Typography component="span" variant="body2">
                      Please select or enter a reaction.
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="flex-start"
                marginBottom={2}
              >
                {data?.allergiesList?.map((item: any, index: any) => {
                  return (
                    <Grid item xs={12} md={4} lg={3} key={index}>
                      <CheckboxField>
                        <input
                          id={index + "allergies"}
                          name="AllergiesList"
                          type="checkbox"
                          value={item?.allergyId}
                          defaultChecked={item?.allergyFlag}
                          onChange={registerProps.handleChange}
                        />

                        <label htmlFor={index + "allergies"}>
                          {item?.allergyName}
                        </label>
                      </CheckboxField>
                    </Grid>
                  );
                })}
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="flex-start"
              >
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="otherR"
                      marginBottom={3}
                    >
                      Other Reactions
                      <Typography
                        component="span"
                        color="error"
                        variant="body2"
                      >
                        *
                      </Typography>
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      ></Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInput
                        id="otherR"
                        name="otherRecations"
                        type="text"
                        className=""
                        placeholder="Enter Your Reactions"
                      />
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="clinicextraname"
                      marginLeft={3}
                    >
                      Onset Date
                    </Typography>{" "}
                    <Box>
                      <DatePickerField>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="MM/dd/yyyy"
                            value={registerProps.values.onSetDate}
                            onChange={(e) => {
                              if (e === null) {
                                registerProps.setFieldValue("onSetDate", "");
                              } else {
                                registerProps.setFieldValue(
                                  "onSetDate",
                                  moment(e).format("MM/DD/yyyy")
                                );
                              }
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </DatePickerField>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="note"
                    >
                      Note
                    </Typography>{" "}
                    <Box>
                      <DRxTextareaStyle>
                        <DRxTextarea
                          id="note"
                          name="note"
                          className=""
                          placeholder="Enter Notes"
                        />
                      </DRxTextareaStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12}>
                  <BtnSMGroupStyle style={{ textAlign: "right" }}>
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="contained"
                      disabled={false}
                      type="submit"
                      children={"Update"}
                    />{" "}
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="button"
                      children={"Cancel"}
                      onClick={props.handleHidePopupClick}
                    />
                  </BtnSMGroupStyle>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      )}

      <YSSnackBar
        message={AddorEditState.message}
        variant={AddorEditState.variant}
        open={AddorEditState.open}
        handleClose={() => {
          setAddorEditState((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
